const __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
    function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
    function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

const CLASS_DRAWER_OPEN = 'is-drawer-open';
const CLASS_SCROLL_DISABLED = 'is-scroll-disabled';
const CLASS_ACTIVE = 'is-active';
const CLASS_LOADING = 'is-loading';
const CLASS_LOADED = 'is-loaded';
const CLASS_HIDDEN = 'is-hidden';
const CLASS_HAS_VALUES = 'has-values';
const CLASS_HAS_ERROR = 'has-error';
const CLASS_OPEN = 'is-open';
const SEL_TEMPLATE_CONTAINER = '[data-magic-fit]';
const SEL_MAGIC_FIT_DRAWER_TOGGLE = '[data-magic-fit-drawer-toggle]';
const SEL_MAGIC_FIT_SIZE_FINDER_KEY = '[data-magic-fit-size-finder-key]';
const SEL_MAGIC_FIT_DRAWER = '[data-magic-fit-drawer]';
const SEL_MAGIC_FIT_DRAWER_BACK = '[data-drawer-back]';
const SEL_MAGIC_FIT_SIZE_FORM = '[data-magic-fit-size-form]';
const SEL_MAGIC_FIT_FORM_STEPS = 'data-magic-fit-step';
const SEL_MAGIC_FIT_DATA_CONTAINER = '[data-magic-fit-data-container]';
const SEL_MAGIC_FIT_DATA = 'data-magic-fit-data';
const SEL_GENDER_FIELD_GROUP = '[data-gender-field-group]';
const SEL_GENDER_RADIO_MALE = '#male';
const SEL_GENDER_RADIO_FEMALE = '#female';
const SEL_SIZE_FIELDS = '[data-size-field-group]';
const SEL_HEIGHT = '#height';
const SEL_RANGE_VALUE = '[data-unit-value]';
const SEL_WEIGHT = '#weight';
const SEL_BRA_FIELD_GROUP = '[data-bra-field-group]';
const SEL_BRA_SIZE_SELECT = 'data-size-select';
const SEL_BRA_SIZE_CONVERT_BTN = 'data-bra-size-convert-btn';
const SEL_BRA_DROPDOWN = 'data-size-select-dropdown';
const SEL_AGE = '[data-magic-fit-age]';
const SEL_LOADING_HEIGHT_VALUE = '#loading-height-value';
const SEL_LOADING_HEIGHT_UNIT = '#loading-height-unit';
const SEL_LOADING_WEIGHT_VALUE = '#loading-weight-value';
const SEL_LOADING_WEIGHT_UNIT = '#loading-weight-unit';
const SEL_LOADING_AGE_VALUE = '#loading-age-value';
const SEL_LOADING_AGE_UNIT = '#loading-age-unit';
const SEL_LOADING_STEP = '[data-magic-fit-loading]';
const SEL_SUBSCRIBE_FORM_STEP = '[data-magic-fit-subscribe-step]';
const SEL_SUBSCRIBE_FORM = '[data-magic-fit-subscribe-form]';
const SEL_SUBSCRIBE_EMAIL = '[data-subscribe-field]';
const SEL_SUBSCRIBE_SKIP = '[data-subscribe-skip]';
const SEL_RESULT_IMAGE = '[data-results-image]';
const SEL_RESULT_SIZE_TEXT = '[data-result-size-regular]';
const SEL_RESULT_PILLS = '[data-results-pill]';
const SEL_DRAWER_TITLE = '[data-drawer-title]';

const SEL_NOTE_TOGGLE_LABEL = '#note-toggle-label';
const SEL_NOTE_TEXT = '#note';
const SEL_NOTE_FORM = '[data-note-form]';
const SEL_NOTE_FORM_TOGGLE = '[data-note-form-toggle]';
const SEL_TAGS_CHECKBOXES = 'input[name=tags]';
const SEL_NOTE_FORM_TAGS_COUNT = '[data-note-form-tags-count]';
const SEL_TOOLTIP = '[data-tooltip]';
const SEL_CONTENT_DRAWER_TOGGLE = '[data-returns-content-drawer-toggle]';
const SEL_CONTENT_DRAWER = "[data-returns-content-drawer]";
const SEL_CAROUSEL_CONTAINER = "[data-carousel-container]";
const SEL_CAROUSEL = "[data-carousel-slider]";
const SEL_CAROUSEL_SLIDES = "[data-carousel-slide]";
const SEL_CAROUSEL_ARROW_PREVIOUS = "[data-carousel-prev]";
const SEL_CAROUSEL_ARROW_NEXT = "[data-carousel-next]";
const SEL_DOTS = '[data-carousel-dots]';

const MAGIC_FIT_SIZE_FINDER_KEY = 'data-magic-fit-size-finder-key';
const MAGIC_FIT_SIZE_FINDER_STORE_NAME = 'data-magic-fit-store-name';

var body = document.body;
const CAROUSEL_OPTIONS = {
  "loop": 1,
  "slidesPerView": 1,
  "spacing": 0,
  "duration": 700,
};
let magicFitData = {
  gender: null,
  height: null,
  weight: null,
  age: null,
  braSize: null,
  note: null,
  fitTags: null
};
let braSizeData = {
  unit: null,
  band: null,
  cup: null
};

class MagicFit {
  constructor() {
    this.isDrawerOpened = false;
    this.drawerToggleBtns = [];
    this.drawer = null;
    this.drawerBack = null;
    this.formSteps = null;
    this.dataContainer = null;
    this.dataLabel = null;
    this.genderFieldGroup = null;
    this.genderRadioMale = null;
    this.genderRadioFemale = null;
    this.sizeForm = null;
    this.sizeFields = null;
    this.heightInput = null;
    this.weightInput = null;
    this.braFieldGroup = null;
    this.braSelect = null;
    this.braSizeSelect = [];
    this.braSizeConvertBtns = [];
    this.braSizeSelectDropdown = null;
    this.ageInput = null;
    this.birthdayInputMonth = null;
    this.birthdayInputYear = null;
    this.loadingHeightValue = null;
    this.loadingHeightUnit = null;
    this.loadingWeightValue = null;
    this.loadingWeightUnit = null;
    this.loadingAgeValue = null;
    this.loadingAgeUnit = null;
    this.loadingStep = null;
    this.subscribeFormStep = null;
    this.subscribeForm = null;
    this.subscribeEmailField = null;
    this.subscribeSkip = null;
    this.resultsPills = []
    this.resultsPillWrappers = [];
    this.resultsLines = [];
    this.resultStandardSizeText = null;
    this.noteToggleLabel = null;
    this.noteText = null;
    this.noteForm = null;
    this.noteFormToggles = [];
    this.noteFormTagsCount = null;
    this.isNoteFormOpen = false;
    this.fitTags = [];
    this.storedFitTag = null;
    this.currentStep = 1;
    this.contentDrawerToggleBtns = [];
    this.contentDrawer = null;
    this.carouselElement = null;
    this.carousel = null;
    this.carouselOptions = {};
    this.dots = null;
    this.carouselSlides = null;
    this.carouseArrowPrevious = null;
    this.carouseArrowNext = null;
    this.productHandle = window.location.pathname.split('/').pop(); // Set productHandle here
    this.productSizeFinderKey = null;
    this.productObject = null;
    this.productTitle = null;
  }
  queryChildren(container) {
    this.parent = container;
    this.drawerToggleBtns = document.querySelectorAll(SEL_MAGIC_FIT_DRAWER_TOGGLE);
    this.drawer = document.querySelector(SEL_MAGIC_FIT_DRAWER);
    this.drawerBack = document.querySelector(SEL_MAGIC_FIT_DRAWER_BACK);
    this.formSteps = document.querySelectorAll(`[${SEL_MAGIC_FIT_FORM_STEPS}]`);
    this.dataContainer = document.querySelector(SEL_MAGIC_FIT_DATA_CONTAINER);
    this.dataLabel = document.querySelector(`[${SEL_MAGIC_FIT_DATA}]`);
    this.genderFieldGroup = container.querySelector(SEL_GENDER_FIELD_GROUP);
    this.genderRadioMale = container.querySelector(SEL_GENDER_RADIO_MALE);
    this.genderRadioFemale = container.querySelector(SEL_GENDER_RADIO_FEMALE);
    this.sizeForm = container.querySelector(SEL_MAGIC_FIT_SIZE_FORM);
    this.sizeFields = document.querySelectorAll(SEL_SIZE_FIELDS);
    this.heightInput = container.querySelector(SEL_HEIGHT);
    this.weightInput = container.querySelector(SEL_WEIGHT);
    this.braFieldGroup = container.querySelector(SEL_BRA_FIELD_GROUP);
    this.braSizeSelect = document.querySelectorAll(`[${SEL_BRA_SIZE_SELECT}]`);
    this.braSizeSelectDropdown = document.querySelectorAll(`[${SEL_BRA_DROPDOWN}]`);
    this.braSizeConvertBtns = document.querySelectorAll(`[${SEL_BRA_SIZE_CONVERT_BTN}]`);
    this.ageInput = container.querySelector(SEL_AGE);
    this.loadingHeightValue = container.querySelector(SEL_LOADING_HEIGHT_VALUE);
    this.loadingHeightUnit = container.querySelector(SEL_LOADING_HEIGHT_UNIT);
    this.loadingWeightValue = container.querySelector(SEL_LOADING_WEIGHT_VALUE);
    this.loadingWeightUnit = container.querySelector(SEL_LOADING_WEIGHT_UNIT);
    this.loadingAgeValue = container.querySelector(SEL_LOADING_AGE_VALUE);
    this.loadingAgeUnit = container.querySelector(SEL_LOADING_AGE_UNIT);
    this.loadingStep = container.querySelector(SEL_LOADING_STEP);
    this.subscribeFormStep = container.querySelector(SEL_SUBSCRIBE_FORM_STEP);
    this.subscribeForm = container.querySelector(SEL_SUBSCRIBE_FORM);
    this.subscribeEmailField = container.querySelector(SEL_SUBSCRIBE_EMAIL);
    this.subscribeSkip = container.querySelector(SEL_SUBSCRIBE_SKIP);
    this.resultsPills = container.querySelectorAll(SEL_RESULT_PILLS);
    this.resultStandardSizeText = container.querySelector(SEL_RESULT_SIZE_TEXT);
    this.drawerTitle = container.querySelector(SEL_DRAWER_TITLE);
    this.noteToggleLabel = container.querySelector(SEL_NOTE_TOGGLE_LABEL);
    this.noteText = container.querySelector(SEL_NOTE_TEXT);
    this.noteForm = container.querySelector(SEL_NOTE_FORM);
    this.noteFormToggles = document.querySelectorAll(SEL_NOTE_FORM_TOGGLE);
    this.noteFormTagsCount = container.querySelector(SEL_NOTE_FORM_TAGS_COUNT);
    this.isNoteFormOpen = false;
    this.fitTags = document.querySelectorAll(SEL_TAGS_CHECKBOXES);
    this.tooltip = container.querySelector(SEL_TOOLTIP);
    // this.magicFitURL = new URL("https://3938e333y8.execute-api.ap-southeast-2.amazonaws.com/dev/Size-Zer0-Staging_NODE14/");
    this.magicFitURL = new URL("https://3938e333y8.execute-api.ap-southeast-2.amazonaws.com/dev/Size-Zer0_NODE14");
    this.contentDrawerToggleBtns = document.querySelectorAll(SEL_CONTENT_DRAWER_TOGGLE);
    this.contentDrawer = container.querySelector(SEL_CONTENT_DRAWER);
    this.carouselElement = container.querySelector(SEL_CAROUSEL);
    this.carouselOptions = CAROUSEL_OPTIONS;
    this.carouselSlides = document.querySelectorAll(SEL_CAROUSEL_SLIDES);
    this.carouseArrowPrevious = container.querySelector(SEL_CAROUSEL_ARROW_PREVIOUS);
    this.carouseArrowNext = container.querySelector(SEL_CAROUSEL_ARROW_NEXT);

    this.productSizeFinderKey = document.querySelector(SEL_MAGIC_FIT_SIZE_FINDER_KEY).getAttribute(MAGIC_FIT_SIZE_FINDER_KEY);
    this.sizeFinderStoreName = document.querySelector(SEL_MAGIC_FIT_SIZE_FINDER_KEY).getAttribute(MAGIC_FIT_SIZE_FINDER_STORE_NAME);
  };

  async getProductObject(productHandle) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/products/" + productHandle + ".js",
        method: "GET",
        dataType: "json",
        mode: "no-cors", // This disables CORS checks
        success: (product) => {
          this.productTitle = product.title;
          this.productObject = this.getProductIds(product);
          this.productSizeFinderKey = document.querySelector(SEL_MAGIC_FIT_SIZE_FINDER_KEY).getAttribute(MAGIC_FIT_SIZE_FINDER_KEY);
          this.sizeFinderStoreName = document.querySelector(SEL_MAGIC_FIT_SIZE_FINDER_KEY).getAttribute(MAGIC_FIT_SIZE_FINDER_STORE_NAME);
          resolve(this.productObject);
        },
        error: (jqXHR, textStatus, errorThrown) => {
          reject(errorThrown);
        }
      });
    });
  };
  getProductIds(product) {

    const sizeOptions = product.options.find(option => option.name.toLowerCase() === 'size');
    if (sizeOptions) {
      const sizeVariants = sizeOptions.values.map(size => {
        const variant = product.variants.find(variant => variant.option1 === size);
        return {
          size: size,
          variant_id: variant.id,
          inventory_quantity: variant.inventory_quantity
        };
      });
      return sizeVariants;
    }
    return [];

  }
  onContentDrawerToggle = (e) => {
    var _a;
    e.preventDefault();
    (_a = this.contentDrawer) === null || _a === void 0 ? void 0 : _a.classList.toggle(CLASS_DRAWER_OPEN);
    body.classList.toggle(CLASS_SCROLL_DISABLED);
  };
  updateDOB = () => {
    var _a;
    function formatDate(y, m, d) {
      var date = new Date(y, m, d),
        month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    }
    if (this.ageInput) {
      _a = this.ageInput.value;
      const today = new Date();
      const birthYear = today.getFullYear() - _a;
      magicFitData['dob'] = formatDate(birthYear, 0, 1);
    }
    const details = {
      type: 'dob',
      value: magicFitData['dob']
    };
    document.dispatchEvent(new CustomEvent("magic-fit-modified", { "detail": details }));
  };
  updateGender = () => {
    if (this.genderFieldGroup) {
      const getGender = document.querySelector('input[name="gender"]:checked');
      magicFitData['gender'] = getGender.value;
      if (this.braFieldGroup) {
        magicFitData['gender'] == 'female' ? this.showBraFields() : this.hideBraFields();
      }
      const details = {
        type: 'gender',
        value: magicFitData['gender']
      };
      document.dispatchEvent(new CustomEvent("magic-fit-modified", { "detail": details }));
    }
  };
  getBraDetails = () => {
    // Get bra unit
    const unitElement = container.querySelector(`[${SEL_BRA_SIZE_CONVERT_BTN}].${CLASS_ACTIVE}`);
    const unitValue = unitElement === null || unitElement === void 0 ? void 0 : unitElement.getAttribute(SEL_BRA_SIZE_CONVERT_BTN);
    if (unitValue) {
      braSizeData['unit'] = unitValue;
    }
    // get bra band and cup from active unit
    const activeBandSize = container.querySelector(`#${unitValue}-band-size`);
    activeBandSize ? braSizeData['band'] = activeBandSize.value : null;
    const activeCupSize = container.querySelector(`#${unitValue}-cup-size`);
    activeCupSize ? braSizeData['cup'] = activeCupSize.value : null;
    let braDetails = '';
    for (const key in braSizeData) {
      if (braSizeData[key] != null && braSizeData[key] != 'null') {
        braDetails += braSizeData[key].toUpperCase();
      }
      else {
        braDetails = ''; // Do not display bra details if any value is blank
      }
    }


    if (braDetails != '') {
      magicFitData['braSize'] = braDetails;
      const details = {
        type: 'braSize',
        value: magicFitData['braSize']
      };
      document.dispatchEvent(new CustomEvent("magic-fit-modified", { "detail": details }));
    }
  };
  updateMagicFitData = (e) => {
    var _a;
    const newData = e.detail;
    const storedData = magicFit.getStoredMagicFit();

    if (newData) {
      newData.type == 'gender' || newData.type == 'braSize' || newData.type == 'dob' ?
        magicFitData[newData.type] = newData.value :
        magicFitData[newData.type] = newData.value + newData.unit;
    }
    else if (storedData) {
      for (const key in storedData) {
        magicFitData[key] = storedData[key];
      }
      // set and display gender correctly
      if (magicFitData['gender'] && magicFitData['gender'] == 'female') {
        if (this.genderRadioFemale) {
          this.genderRadioFemale.checked = true;
        }
      }
      else if (magicFitData['gender'] && magicFitData['gender'] == 'male') {
        this.hideBraFields();
        if (this.genderRadioMale) {
          this.genderRadioMale.checked = true;
        }
      }
      // pre-fill height and weight if localstorage values exist
      this.heightInput && magicFitData['height'] ? this.heightInput.value = magicFitData['height'].match(/\d+/)[0] : null;
      this.weightInput && magicFitData['weight'] ? this.weightInput.value = magicFitData['weight'].match(/\d+/)[0] : null;
      // pre-fill dob if localstorage value exists
      if (magicFitData['dob'] && this.ageInput) {
        var storedDob = magicFitData['dob'];
        this.ageInput.value = this.getAge(storedDob);
      }
      // pre-fill bra size if localstorage value exists
      if (magicFitData['braSize']) {
        const storedBraSize = magicFitData['braSize'].split(/(\d+)/);
        const activeButton = container.querySelector(`[${SEL_BRA_SIZE_CONVERT_BTN}="${storedBraSize[0].toLowerCase()}"]`);
        activeButton ? this.handleBraSizeConvert(activeButton) : null;
        const activeBandSize = container.querySelector(`#${storedBraSize[0].toLowerCase()}-band-size`);
        activeBandSize ? activeBandSize.value = storedBraSize[1] : null;
        const activeCupSize = container.querySelector(`#${storedBraSize[0].toLowerCase()}-cup-size`);
        activeCupSize ? activeCupSize.value = storedBraSize[2] : null;
      }
      // pre-fill note if localstorage value exists
      if (magicFitData['note']) {
        this.noteToggleLabel ? this.noteToggleLabel.textContent = magicFitData['note'].toUpperCase() : null;
        this.noteText ? this.noteText.value = magicFitData['note'] : null;
      }

      this.updateMagicFitDisplay();
    }
    else {
    }
  };
  onDrawerToggle = (e) => {
    var _a, _b;
    e === null || e === void 0 ? void 0 : e.preventDefault();
    (_a = this.drawer) === null || _a === void 0 ? void 0 : _a.classList.toggle(CLASS_DRAWER_OPEN);
    body = document.body;
    body.classList.toggle(CLASS_SCROLL_DISABLED);
    this.isDrawerOpened = !this.isDrawerOpened;
    const target = e === null || e === void 0 ? void 0 : e.currentTarget;
    const targetAttribute = target === null || target === void 0 ? void 0 : target.getAttribute('data-magic-fit-drawer-toggle');
    if (this.isDrawerOpened === false) {
      if (this.isNoteFormOpen == true) {
        this.handleNoteFormToggle();
      }
      document.dispatchEvent(new CustomEvent('magic-fit-closed', { bubbles: true }));
      (_b = this.tooltip) === null || _b === void 0 ? void 0 : _b.classList.remove(CLASS_OPEN);
    }
    if (target && targetAttribute && this.isDrawerOpened === false) {
      let sectionId = document.querySelector('product-info').getAttribute('data-section');
      let atcButton = document.getElementById(`ProductSubmitButton-${sectionId}`)
      var selectedSize = document.querySelector('input[name="size"]:checked')
      const variantId = selectedSize.getAttribute('data-variant-id');
      const optionValue = selectedSize.getAttribute('data-result-size');
      if (targetAttribute == 'ATC' && atcButton) {
        this.updateVariantInputs(variantId, optionValue);
        atcButton.click();
      }
    }
  };
  attachEvents(container) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;

    if (window) {
      window.addEventListener('DOMContentLoaded', (e) => this.updateMagicFitData(e));
      window.addEventListener('DOMContentLoaded', (e) => this.updateGender());
      // window.addEventListener('DOMContentLoaded', (e) => this.updateMagicFitSplitTest());
    }

    if (this.drawerToggleBtns) {
      this.drawerToggleBtns.forEach(e => {
        e.removeEventListener('click', this.onDrawerToggle);

        e.addEventListener('click', this.onDrawerToggle);
      });
    }

    if (this.sizeForm) {
      // Remove any existing event listeners before adding a new one
      this.sizeForm.removeEventListener('submit', this.handleSizeFormSubmitBound);
      this.handleSizeFormSubmitBound = this.handleSizeFormSubmit.bind(this);
      this.sizeForm.addEventListener('submit', this.handleSizeFormSubmitBound);
    }
    if (this.genderFieldGroup) {
      new MagicFitGenderField(this.genderFieldGroup);
      this.genderFieldGroup.addEventListener('change', (e) => this.updateGender());
    }

    if (this.subscribeForm) {
      this.subscribeForm.addEventListener('submit', (e) => this.handleSubscribeFormSubmit(e));
    }
    if (this.subscribeSkip) {
      this.subscribeSkip.addEventListener('click', () => {
        this.updateFormStep(4, false);
      });
    }
    if (this.noteFormToggles) {
      this.noteFormToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => this.handleNoteFormToggle());
      });
    }
    if (this.noteForm) {
      this.noteForm.addEventListener('submit', e => this.handleNoteFormSubmit(e));
    }

    if (this.drawerBack) {
      this.drawerBack.addEventListener('click', (e) => this.handleBack(e));
    }

    if (this.braSizeSelectDropdown) {
      this.braSizeSelectDropdown.forEach(select => {
        select.addEventListener('change', () => this.getBraDetails());
      });
    }

    if (this.braSizeConvertBtns && this.braSizeSelect) {
      const activeButton = Array.from(this.braSizeConvertBtns).find(button => button.classList.contains(CLASS_ACTIVE));
      if (!activeButton) {
        this.braSizeSelect[0]?.classList.add(CLASS_ACTIVE);
        this.braSizeConvertBtns[0]?.classList.add(CLASS_ACTIVE);
      }

      this.braSizeConvertBtns.forEach(button => {
        button.addEventListener('click', () => this.handleBraSizeConvert(button));
      });
    }

    if (this.heightInput) {
      this.heightInput.addEventListener('input', (e) => {
        magicFitData['height'] = e.target.value;
        const details = {
          type: 'height',
          value: magicFitData['height'],
          unit: 'cm'
        };
        document.dispatchEvent(new CustomEvent("magic-fit-modified", { "detail": details }));
      });
    }

    if (this.weightInput) {
      this.weightInput.addEventListener('input', (e) => {
        magicFitData['weight'] = e.target.value;
        const details = {
          type: 'weight',
          value: magicFitData['weight'],
          unit: 'kg'
        };
        document.dispatchEvent(new CustomEvent("magic-fit-modified", { "detail": details }));
      });
    }

    if (this.ageInput) {
      this.ageInput.addEventListener('change', (e) => this.updateDOB());
    }
    document.addEventListener('magic-fit-modified', e => this.updateMagicFitData(e));

    if (this.contentDrawerToggleBtns) {
      this.contentDrawerToggleBtns.forEach(e => {
        e.addEventListener('click', this.onContentDrawerToggle);
      });
    }

    if (this.resultsPills) {
      this.resultsPills.forEach(pill => {
        pill.addEventListener('click', () => {
          this.resultsPills.forEach(line => line.classList.remove(CLASS_ACTIVE));
          pill.classList.add(CLASS_ACTIVE);
        });
      });
    }
  }
  updateMagicFitSplitTest() {
    const magicFitSplitTest = document.getElementById('MagicFitSplitTest');
    if (magicFitSplitTest) {
      this.drawerToggleBtns.forEach(btn => {
        btn.style.display = 'none';
      });
    } else {
      this.drawerToggleBtns.forEach(btn => {
        btn.style.display = 'flex';
      });
    }
  }
  hideBraFields() {
    this.braFieldGroup ? this.braFieldGroup.style.display = 'none' : null;
  }
  showBraFields() {
    this.braFieldGroup ? this.braFieldGroup.style.display = 'flex' : null;
  }
  updateVariantInputs(variantId, optionValue) {
    this.form = document.querySelector('product-form');
    this.variantsPicker = document.querySelector('.cstm_label_main');
    this.variantInputId = this.form.querySelector('input[name="id"]');
    this.variantInputId.setAttribute('value', variantId);
    this.variantsPicker.querySelector(`input[value="${optionValue}"]`).checked = true
  }
  updateMagicFitDisplay() {
    var _a, _b, _c;
    const label = [];
    for (const key in magicFitData) {
      if (key == 'gender' || key == 'note' || key == 'fitTags') {
        continue;
      }
      if (magicFitData[key]) {
        label.push(magicFitData[key]);
      }
    }
    if (this.dataLabel) {
      this.dataLabel.innerText = label.join(', ');
      this.dataLabel.setAttribute(SEL_MAGIC_FIT_DATA, JSON.stringify(magicFitData));
      (_a = this.dataContainer) === null || _a === void 0 ? void 0 : _a.classList.remove(CLASS_HAS_ERROR);
      if (label.length) {
        (_b = this.dataContainer) === null || _b === void 0 ? void 0 : _b.classList.add(CLASS_HAS_VALUES);
      }
      else {
        (_c = this.dataContainer) === null || _c === void 0 ? void 0 : _c.classList.remove(CLASS_HAS_VALUES);
      }
    }
  }
  getAge(dob) {
    if (dob) {
      const today = new Date();
      const birthDate = new Date(dob);
      let difference = (today) - (birthDate);
      let totalDay = difference / (1000 * 3600 * 24);
      let age = parseInt((totalDay / 365).toFixed(0));
      age = age > 0 ? age.toFixed(0) : null;

      return age
    }
  }
  storeMagicFit(magicFit) {
    if (magicFit['gender'] == "male") {
      magicFit['braSize'] = null;
    }

    const initUser = JSON.parse(localStorage.getItem('user') || '{}')
    initUser['magic-fit'] = magicFit
    localStorage.setItem('user', JSON.stringify(initUser))
  }
  getStoredMagicFit() {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    const userMagicFit = user['magic-fit']
    return userMagicFit;
  }
  updateFormStep(step, isLoadingStep) {
    var _a;
    this.currentStep = step;
    this.parent.classList.toggle(CLASS_LOADING, isLoadingStep);
    (_a = this.formSteps) === null || _a === void 0 ? void 0 : _a.forEach(formStep => {
      formStep.classList.toggle(CLASS_ACTIVE, Number(formStep.getAttribute(SEL_MAGIC_FIT_FORM_STEPS)) === this.currentStep);
    });
  }
  handleBraSizeConvert(convertButton) {
    const sizeType = convertButton === null || convertButton === void 0 ? void 0 : convertButton.getAttribute(SEL_BRA_SIZE_CONVERT_BTN);
    if (!sizeType) return;

    this.braSizeConvertBtns.forEach(button => {
      button.classList.remove(CLASS_ACTIVE)
    });

    convertButton.classList.add(CLASS_ACTIVE);

    this.braSizeSelect.forEach(wrapper => {
      wrapper.classList.toggle(CLASS_ACTIVE, wrapper.getAttribute(SEL_BRA_SIZE_SELECT) === sizeType);
    });

    this.getBraDetails();
  }
  handleBack(e) {
    var _a, _b;
    let previousStep = this.currentStep > 1 ? this.currentStep - 1 : 1;
    if (previousStep == 2 || previousStep == 3) {
      previousStep = 1;
      (_a = this.drawerBack) === null || _a === void 0 ? void 0 : _a.classList.add('is-hidden');
    }
    (_b = this.loadingStep) === null || _b === void 0 ? void 0 : _b.classList.remove(CLASS_LOADED);
    this.updateFormStep(previousStep, false);
  }
  handleSizeFormSubmit(e) {
    return __awaiter(this, void 0, void 0, function* () {
      var _a, _b, _c;
      e.preventDefault();

      // Validate bra fields for female users
      if (magicFitData['gender'] === 'female') {
        // Get the active bra size select elements
        const activeBraSizeSelect = Array.from(this.braSizeSelect).find(select => select.classList.contains(CLASS_ACTIVE));
        // Get the band and cup size values
        const braBandSelect = activeBraSizeSelect.querySelector(`#${activeBraSizeSelect.getAttribute(SEL_BRA_SIZE_SELECT)}-band-size`);
        const braCupSelect = activeBraSizeSelect.querySelector(`#${activeBraSizeSelect.getAttribute(SEL_BRA_SIZE_SELECT)}-cup-size`);

        // Check if both values are selected
        if (braBandSelect.value == null || braBandSelect.value == "null" || braCupSelect.value == null || braCupSelect.value == "null") {
          document.querySelector('.c-magic-fit__field-error').style.display = "none";
          setTimeout(() => {
            document.querySelector('.c-magic-fit__field-error').style.display = "unset";
          }, 300);
          return false; // Prevent form submission
        }
      }


      magicFit.storeMagicFit(magicFitData);
      (_a = this.drawerBack) === null || _a === void 0 ? void 0 : _a.classList.remove('is-hidden');
      this.setLoadingScreenValues(magicFitData);
      this.updateFormStep(2, true);


      magicFitData['productTitle'] = this.productTitle;
      magicFitData['productObject'] = this.productObject;
      magicFitData['productHandle'] = this.productHandle;
      magicFitData['productSizeFinderKey'] = this.productSizeFinderKey;
      magicFitData['storeName'] = this.sizeFinderStoreName;
      magicFitData['function'] = 'SizeFinder'

      const cart = yield fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => response.json());


      // send magic fit request here
      const response = yield fetch(this.magicFitURL, {
        method: 'POST',
        body: JSON.stringify(magicFitData)
      });
      const result = yield response.json();

      this.setResultsPills(result);

      cart.attributes = cart.attributes || {};
      let index = 1;
      while (cart.attributes[`magic_fit_product_${index}`]) {
        index++;
      }
      cart.attributes[`magic_fit_product_${index}`] = JSON.stringify({
        gender: magicFitData['gender'],
        height: magicFitData['height'],
        weight: magicFitData['weight'],
        dob: magicFitData['dob'],
        braSize: magicFitData['braSize'],
        productTitle: this.productTitle,
        size: result['size']
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cart)
      }).then(response => response.json())
        .then(updatedCart => {
          console.log('Cart updated with note:', updatedCart);
        }).catch(error => {
          console.error('Error updating cart:', error);
        });


      setTimeout(() => {
        (_b = this.loadingStep) === null || _b === void 0 ? void 0 : _b.classList.add(CLASS_LOADED);
      }, 1000);

      setTimeout(() => {
        if (result['fits'] && result['fits']['regular']['size']) {
          this.updateFormStep(3, false);
        } else {
          this.updateFormStep(4, false);
        }
      }, 2500);
    });
  }
  setResultsPills(result) {
    if (result['fits'] && result['fits']['regular']['size']) {
      const regularFitSize = result['fits']['regular']['size'];
      this.resultsPills.forEach(resultPill => {
        resultPill.classList.remove(CLASS_HIDDEN);

        const fit = resultPill.getAttribute('data-results-pill');

        if (fit != 'regular' && result['fits'][fit]['size'] == regularFitSize) {
          resultPill.classList.add(CLASS_HIDDEN);
        } else {
          this.sizeText = resultPill.querySelectorAll('[data-result-size');
          this.sizeText.forEach(text => {
            text.textContent = result['fits'][fit]['size'];
            text.setAttribute('data-result-size', result['fits'][fit]['size']);
            text.setAttribute('data-variant-id', result['fits'][fit]['variant_id'])
          });
        }

        if (fit == 'regular') {
          this.resultStandardSizeText.textContent = result['fits'][fit]['size'];
        }
      });
    } else {
      console.log('No results found');
    }

  }

  colourChangeUpdate() {
    this.drawerTitle.textContent = this.productTitle;
    this.resultsPills.forEach(resultPill => {
      const inputElement = resultPill.querySelector('input');
      const size = inputElement.getAttribute('data-result-size');

      if (size) {
        const variant = this.productObject.find(variant => variant.size === size);
        if (variant) {
          resultPill.querySelector('input').setAttribute('data-variant-id', variant.variant_id);
        }
      }
    });
  }

  setLoadingScreenValues(magicFit) {
    this.loadingHeightValue ? this.loadingHeightValue.textContent = magicFit['height'].split(/(\d+)/)[1] : null;
    this.loadingHeightUnit ? this.loadingHeightUnit.textContent = magicFit['height'].split(/(\d+)/)[2].toUpperCase() : null;
    this.loadingWeightValue ? this.loadingWeightValue.textContent = magicFit['weight'].split(/(\d+)/)[1] : null;
    this.loadingWeightUnit ? this.loadingWeightUnit.textContent = magicFit['weight'].split(/(\d+)/)[2].toUpperCase() : null;
    const age = this.getAge(magicFit['dob']);
    this.loadingAgeValue ? this.loadingAgeValue.textContent = age : null;
  }

  detatchEvents(container) {
  }
}

const SEL_RADIOS = '[data-gender-radio]'
const SEL_INDICATOR = '[data-selected-indicator]'

class MagicFitGenderField {
  constructor(parent) {
    this.radios = null;
    this.selectedIndicator = null;
    if (!parent) return;
    const storedMagicFit = magicFit.getStoredMagicFit();
    this.radios = parent.querySelectorAll(SEL_RADIOS);
    this.selectedIndicator = parent.querySelector(SEL_INDICATOR);
    // if stored gender doesn't match first radio, toggle radio selected indicator
    if (storedMagicFit && storedMagicFit['gender'] && storedMagicFit['gender'] != this.radios[0].id) {
      this.handleRadioChange(this.radios[1]);
    }

    this.attachEvents();
  }

  attachEvents() {
    if (this.radios) {
      this.radios.forEach(radio => radio.addEventListener('change', () => this.handleRadioChange(radio)));
    }
  }

  handleRadioChange(radio) {
    if (!radio || !this.selectedIndicator) return;

    const parentElement = radio.parentElement;

    this.selectedIndicator.style.width = `${parentElement?.offsetWidth}px`;
    this.selectedIndicator.style.transform = `translateX(${parentElement?.offsetLeft}px)`;
  }
}

const magicFit = new MagicFit();
document.addEventListener('DOMContentLoaded', () => {
  this.container = document.querySelector(SEL_TEMPLATE_CONTAINER);
  magicFit.queryChildren(this.container);
  magicFit.attachEvents();

  magicFit.getProductObject(magicFit.productHandle); // Use magicFit.productHandle

  var target = document.querySelector('variant-selects').parentElement;

  if (target) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && String(mutation.target.id).includes('ProductInfo-template')) {
          const newProductHandle = window.location.pathname.split('/').pop();
          const newProductSizeFinderKey = document.querySelector(SEL_MAGIC_FIT_SIZE_FINDER_KEY).getAttribute(MAGIC_FIT_SIZE_FINDER_KEY);
          magicFit.queryChildren(document.querySelector(SEL_TEMPLATE_CONTAINER));
          magicFit.attachEvents();
          // magicFit.updateMagicFitSplitTest();
          magicFit.productHandle = newProductHandle;
          magicFit.productSizeFinderKey = newProductSizeFinderKey;
          magicFit.getProductObject(magicFit.productHandle).then(() => {
            magicFit.colourChangeUpdate();
          });
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });
  } else {
  }
});